/**
 * アプリケーション内で使用するユーザーロールの定義。
 * UIや認可処理、表示処理などフロント側のロジックで使用する
 */
export const AppUserRole = {
  SystemAdmin: "SystemAdmin",
  TenantAdmin: "TenantAdmin",
  MarketManager: "MarketManager",
  AreaManager: "AreaManager",
  Worker: "Worker",
} as const;

export const AppUserRoleLabelMap: Record<AppUserRoleType, string> = {
  SystemAdmin: "システム管理者",
  TenantAdmin: "テナント管理者",
  MarketManager: "マーケット管理者",
  AreaManager: "エリア管理者",
  Worker: "清掃担当者",
};

export const getAppUserRoleLabel = (role?: AppUserRoleType) => {
  if (!role || !(role in AppUserRole)) return "不明な権限";
  return AppUserRoleLabelMap[role];
};

export type AppUserRoleType = (typeof AppUserRole)[keyof typeof AppUserRole];
